export function stringToHashNumber(str: string): number {
  // Hash la chaîne pour obtenir un nombre
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash);
}

export function hslToHex(hue: number, saturation: number, lightness: number): string {
  const c = (1 - Math.abs(2 * lightness - 1)) * saturation;
  const x = c * (1 - Math.abs(((hue / 60) % 2) - 1));
  const m = lightness - c/2;

  let r = 0, g = 0, b = 0;

  if (0 <= hue && hue < 60) [r, g, b] = [c, x, 0];
  else if (60 <= hue && hue < 120) [r, g, b] = [x, c, 0];
  else if (120 <= hue && hue < 180) [r, g, b] = [0, c, x];
  else if (180 <= hue && hue < 240) [r, g, b] = [0, x, c];
  else if (240 <= hue && hue < 300) [r, g, b] = [x, 0, c];
  else if (300 <= hue && hue < 360) [r, g, b] = [c, 0, x];

  r = Math.round((r + m) * 255);
  g = Math.round((g + m) * 255);
  b = Math.round((b + m) * 255);

  return `#${[r, g, b].map(x =>
    x.toString(16).padStart(2, '0')).join('')}`;
}
